import React, { useEffect, useState, useContext } from 'react';
import { useParams, NavLink } from 'react-router-dom';
import axios from 'axios';
import './SubCategories.css';
import { Helmet } from 'react-helmet';
import { HomeContext } from '../Context/HomeContext'; // ✅ use context
import SubscribeBox from '../Component/Home/Subscribe';
import { FaCalendarAlt, FaEye } from 'react-icons/fa';


const SubCategoryPage = () => {
  const { slug } = useParams();
  const [blogs, setBlogs] = useState([]);
  const [subcategory, setSubcategory] = useState({});
  const [metaTags, setMetaTags] = useState([]);
  const [loading, setLoading] = useState(true);

  const { homeData } = useContext(HomeContext); // ✅ get from context
  const recentBlogs = homeData?.recentBlogs || [];

  useEffect(() => {
    const fetchBlogs = async () => {
      setLoading(true);
      const options = {
        headers: {
          Accept: 'application/json',
          'Client-Domain':'www.clevercoverageofficial.com',
        },
      };

      try {
        const res = await axios.get(
          `https://api.funfillia.com/api/v2/website/subCategoryBlogs/${slug}`,
          options
        );

        const record = res.data.record || {};
        setBlogs(res.data.blogs?.data || []);
        setSubcategory(record);

        const metaHTML = record.meta_tags || '';
        const doc = new DOMParser().parseFromString(metaHTML, 'text/html');
        const tags = Array.from(doc.head.children);
        setMetaTags(tags);

        document.title = `${record.name || 'Subcategory'} - Clever Coverage`;
      } catch (error) {
        console.error('Error fetching subcategory blogs:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchBlogs();
  }, [slug]);

  const getMetaContent = (attr, value) => {
    const tag = metaTags.find((t) => t.getAttribute(attr) === value);
    return tag?.getAttribute('content') || '';
  };

  if (loading) {
    return (
      <div className="loading-wrapper">
        <div className="spinner"></div>
        <p className="loading-text">Fetching fresh blogs for you...</p>
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>{`${subcategory.name} - Clever Coverage`}</title>

        <meta name="title" content={getMetaContent('name', 'title')} />
        <meta name="description" content={getMetaContent('name', 'description')} />
        <meta name="keywords" content={getMetaContent('name', 'keywords')} />
        <link rel="canonical" href={window.location.href} />

        <meta property="og:type" content={getMetaContent('property', 'og:type') || 'article'} />
        <meta property="og:url" content={getMetaContent('property', 'og:url') || window.location.href} />
        <meta property="og:title" content={getMetaContent('property', 'og:title')} />
        <meta property="og:description" content={getMetaContent('property', 'og:description')} />
        <meta property="og:image" content={getMetaContent('property', 'og:image')} />

        <meta name="twitter:card" content={getMetaContent('name', 'twitter:card')} />
        <meta name="twitter:title" content={getMetaContent('name', 'twitter:title')} />
        <meta name="twitter:description" content={getMetaContent('name', 'twitter:description')} />
        <meta name="twitter:image" content={getMetaContent('name', 'twitter:image')} />
      </Helmet>

      <div className="subcategory-container">
        <div className="main-content">
          <h2 className="subcategory-title">{subcategory.name}</h2>

          {blogs.length === 0 ? (
            <div className="coming-soon-box">
              <h1>🎉 Coming Soon 🎉</h1>
              <p>We’re working on something amazing. Stay tuned!</p>
            </div>
          ) : (
            <div className="blogs-grid">
              {blogs.map((blog) => (
                <NavLink
                  to={`/blog/${blog.slug}`}
                  key={blog.id}
                  className="blog-card"
                >
                  <img
                    src={`https://api.funfillia.com/${blog.image_400x300}`}
                    alt={blog.title}
                    className="blog-img"
                  />
                  <div className="blog-info">
                    <h3>{blog.title}</h3>
                    <p>{blog.short_description}</p>
                    <span className="meta">
                      <FaCalendarAlt/> {new Date(blog.published_at).toLocaleDateString()} &nbsp;&nbsp;
                      <FaEye/> {blog.views_count} views
                    </span>
                  </div>
                </NavLink>
              ))}
            </div>
          )}
        </div>

        <aside className="recent-blogs-sidebar">
          <h3 className="sidebar-title">Recent Blogs</h3>
          <ul className="recent-blog-list">
            {recentBlogs.map((blog) => (
              <li key={blog.id} className="recent-blog-item">
                <NavLink to={`/blog/${blog.slug}`} className="recent-link">
                  <img
                    src={`https://api.funfillia.com/${blog.image_200x200}`}
                    alt={blog.title}
                  />
                  <div>
                    <h4>{blog.title}</h4>
                    <p>{blog.short_description}</p>
                    <span className="meta">
                      <FaCalendarAlt/> {new Date(blog.published_at).toLocaleDateString()} &nbsp;&nbsp;
                      <FaEye/> {blog.views_count || 0} views
                    </span>
                  </div>
                </NavLink>
              </li>
            ))}
          </ul>
        </aside>
      </div>
       <SubscribeBox/>

    </>
  );
};

export default SubCategoryPage;
